import { FerryIcon } from './FerryIcon';

/**
 * author: Google
 * id F138AC6A-406B-4EB0-BB85-0FDB5415B6F8
 * name ferry
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ferry.svg
 * tags
 * - Transportation + Water 
 * - Navigation 
 */
export const ShipIcon = FerryIcon;
export default ShipIcon